import { render } from "./Page-entry.vue?vue&type=template&id=a3539640"
import script from "./Page-entry.vue?vue&type=script&lang=js"
export * from "./Page-entry.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__